import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import cx from 'classnames'
import isObject from 'lodash/isObject'

import {
  removeNotification,
  selectNotifications,
} from 'store/slices/notifications'

import './style.scss'

const NotificationItem = ({ children, notification, ...otherProps }) => {
  const dispatch = useDispatch()
  useEffect(() => {
    setTimeout(() => {
      dispatch(removeNotification(notification.id))
    }, notification.duration)
  }, [])

  return (
    <CSSTransition
      key={notification.id}
      timeout={500}
      classNames="Fade"
      {...otherProps}
    >
      {children}
    </CSSTransition>
  )
}

export default function Notification() {
  const notifications = useSelector(selectNotifications)
  const dispatch = useDispatch()

  return createPortal(
    <div className="Notifications">
      <TransitionGroup>
        {notifications
          .filter((n) => n.variant === 'dialog')
          .map((notification) => (
            <NotificationItem key={notification.id} notification={notification}>
              <div className="Notification__dialog">
                <div
                  className="Notification__dialog__overlay"
                  onClick={() => dispatch(removeNotification(notification.id))}
                />
                <div className="Box">
                  <img
                    className="Notification__dialog__icon"
                    src={
                      notification.type === 'success'
                        ? '/images/icon-check-darkgray.svg'
                        : '/images/icon-x-thin.svg'
                    }
                  />
                  <p
                    dangerouslySetInnerHTML={{ __html: notification.message }}
                  />
                </div>
              </div>
            </NotificationItem>
          ))}
      </TransitionGroup>

      <div className="Notification__snackbar">
        <TransitionGroup component="ul" className="Notification__snackbar__ul">
          {notifications
            .filter((n) => n.variant === 'snackbar')
            .map((notification) => {
              const message =
                isObject(notification.message) || !notification.message
                  ? notification.id
                  : notification.message

              return (
                <NotificationItem
                  key={notification.id}
                  notification={notification}
                >
                  <li
                    className={cx(
                      'Notification__snackbar__ul__li',
                      `Notification__snackbar__ul__li--${notification.type}`
                    )}
                  >
                    <p className="Notification__snackbar__ul__li__p--title">
                      {notification.title}
                    </p>
                    <p
                      className="Notification__snackbar__ul__li__p"
                      dangerouslySetInnerHTML={{ __html: message }}
                    />
                  </li>
                </NotificationItem>
              )
            })}
        </TransitionGroup>
      </div>
    </div>,
    document.querySelector('#notifications')
  )
}
